import React, {useMemo, useState} from "react";

function getUserDeptLabel(user) {
    return user?.department?.name ?? user?.memberOf?.grade?.name ?? "";
}

export default function ApproveUserList({users, loading, values, setValues}) {
    const [searchText, setSearchText] = useState("");
    const addedIds = useMemo(
        () => new Set((values ?? []).map((v) => String(v.actor.id))),
        [values],
    );

    const filtered = useMemo(() => {
        const list = users ?? [];
        const q = searchText.trim().toLowerCase();
        if (!q) return list;
        return list.filter((user) => {
            const name = String(user.name ?? "").toLowerCase();
            const dept = getUserDeptLabel(user).toLowerCase();
            return name.includes(q) || dept.includes(q);
        });
    }, [users, searchText]);

    const toggleUser = (user) => {
        if (addedIds.has(String(user.id))) {
            setValues((prev) => {
                const next = (prev ?? []).filter((v) => String(v.actor.id) !== String(user.id));
                return next.map((item, index) => ({...item, orders: index}));
            });
            return;
        }
        setValues((prev) => [
            ...(prev ?? []),
            {
                orders: prev?.length ?? 0,
                actor: {id: user.id, name: user.name, department: user.department},
            },
        ]);
    };

    return (
        <>
            <div className="search-selector-panel-search-wrap">
                <input
                    type="text"
                    className="search-selector-panel-search"
                    placeholder="사용자명 검색"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                />
            </div>
            <div className="search-selector-panel-list">
                {loading ? (
                    <div className="search-selector-loading">불러오는 중…</div>
                ) : filtered.length === 0 ? (
                    <div className="search-selector-empty">표시할 사용자가 없습니다.</div>
                ) : (
                    <ul className="search-selector-panel-list-inner">
                        {filtered.map((user) => {
                            const isActive = addedIds.has(String(user.id));
                            const meta = getUserDeptLabel(user);
                            return (
                                <li key={user.id}>
                                    <div
                                        className={[
                                            "search-selector-panel-row",
                                            isActive ? "is-active" : "",
                                        ].filter(Boolean).join(" ")}
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => toggleUser(user)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter" || e.key === " ") {
                                                e.preventDefault();
                                                toggleUser(user);
                                            }
                                        }}
                                    >
                                        <span className="search-selector-panel-row-name">{user.name}</span>
                                        {meta ? (
                                            <span className="search-selector-panel-row-meta">{meta}</span>
                                        ) : null}
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>
        </>
    );
}
